import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const PublicRoutes = () => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  
  // If the route is authentication-related and user is already authenticated, redirect
  const isAuthRoute = ['/login', '/register', '/forgot-password', '/reset-password'].includes(location.pathname);
  
  if (isAuthenticated && isAuthRoute) {
    return <Navigate to={user?.role === 'admin' ? '/admin' : '/dashboard'} replace />;
  }
  
  return <Outlet />;
};

export default PublicRoutes;